module.exports = __webpack_public_path__ + "static/media/urls.484bb6ac.png";